import { toast } from 'react-toastify';
import errorHandle from '../../../../utils/errorHandle';
import { tripAvaFun } from '../../../../api/bookingAPI';
import moment from 'moment';
import { detailsRoute } from '../../../../utils/detailsRoute';

export default async function guideBookingClick(
    booking,
    setBookingData,
    setReviewPage,
    tripData,
    setLoading,
    priceDetails
) {
    console.log(booking, 'booking');
    if (booking.people < 1) {
        toast.error('Please select no of people');
        return;
    }
    if (!booking?.place) {
        toast.error('Please select place');
        return;
    }
    if (booking.date === null) {
        toast.error('Please select date');
        return;
    }
    if (booking.timeSlots === '') {
        toast.error('Please select time slot');
        return;
    }
    if (booking.language === '') {
        toast.error('Please select language');
        return;
    }
    if (tripData?.meetupLocation?.length > 1 && !booking?.meetupLocation?.name) {
        toast.error('Please select meetup location');
        return;
    }

    setLoading(true);
    try {
        const { packId, type } = detailsRoute();
        setBookingData({
            ...booking,
            priceDetails,
            amountPaid: {
                ...booking.amountPaid,
                actual: priceDetails.actual,
                tax: priceDetails.tax,
                discount: priceDetails.discount,
                total: priceDetails.total
            },
            title: tripData.title,
            tripImage: tripData.images[0],
            packId: packId,
            organizerId: tripData.organizerId,
            organizerName: tripData.organizerName,
            type: type
        });
        setReviewPage(true);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

// Handle cutsome trip booking
export const handleCustomTripBooking = ({
    booking,
    customBooking,
    packData,
    customFinalPrice,
    setBookingData,
    setReviewPage
}) => {
    // if (customBooking.startDate === null || customBooking.endDate === null) {
    //     toast.error('Please Select Date');
    //     return;
    // } else if (customBooking.startCity === '' || customBooking.startCity === '-1') {
    //     toast.error('Please select start city');
    //     return;
    // } else if (customBooking.pickupLocation === '' || customBooking.pickupLocation === '-1') {
    //     let text = booking.group === 'vehicle' ? 'Please select meetup location' : 'Please select pickup location';
    //     toast.error(text);
    //     return;
    // } else if (!customBooking?.customTrip?.isGroup) {
    //     if (
    //         !customBooking.customTrip.vehicleType ||
    //         !customBooking.customTrip.vehicleType.some((v) => v.vehicleCount > 0)
    //     ) {
    //         toast.error('Please Select Vehicle');
    //         return;
    //     }
    // }
    const totalAdults = customBooking?.customTrip?.rooms?.reduce((acc, room) => acc + room?.adults, 0);
    setBookingData({
        type: 'trip',
        title: packData.title,
        ...customBooking,
        startDate: customBooking.startDate.utc().toISOString(),
        endDate: customBooking.endDate.utc().toISOString(),
        packId: packData._id,
        packDateId: null,
        datesType: packData.datesType,
        group: packData.group,
        itiType: packData.itiType,
        tripImage: packData.images[0],
        organizerId: packData.organizerId,
        organizerName: packData.organizerName,
        people: totalAdults,
        days: packData.days,
        nights: packData.nights
    });

    setReviewPage(true);
};

// Handle update booking click
export const handleUpdateNow = async ({
    type,
    dataToBeUpdated,
    selectedDate,
    confirmedBookingData,
    updateUserBookingDateAndPickupLocation,
    naviagte
}) => {
    let newDate =
        confirmedBookingData.datesType === 'custom'
            ? moment(dataToBeUpdated.startDate).toISOString()
            : dataToBeUpdated?.date;
    let endDate =
        confirmedBookingData.datesType === 'custom'
            ? moment(dataToBeUpdated.endDate).toISOString()
            : selectedDate?.endDate;
    const updateDateBody = {
        bookingId: confirmedBookingData?._id,
        newDate: newDate,
        endDate: endDate
    };

    const updatePickupLocationBody = {
        bookingId: confirmedBookingData?._id,
        pickupLocation: dataToBeUpdated?.pickupLocation
    };

    try {
        const dateFlag = confirmedBookingData.startDate && !confirmedBookingData?.isTripMoreThanOneDays;
        const pickupFlag = confirmedBookingData?.isTripMoreThanOneDays;

        if (dateFlag) {
            const response = await updateUserBookingDateAndPickupLocation(type, dateFlag, false, updateDateBody);
            if (response.status === 200) {
                toast.success('You have Rescheduled the date successfully');
                sessionStorage.removeItem('confirmedBookingData');
                naviagte('/my-booking');
            }
        } else if (pickupFlag) {
            const response = await updateUserBookingDateAndPickupLocation(
                type,
                false,
                pickupFlag,
                updatePickupLocationBody
            );
            if (response.status === 200) {
                toast.success('You have changed the location successfully');
                sessionStorage.removeItem('confirmedBookingData');
                naviagte('/my-booking');
            }
        }
    } catch (error) {
        toast.warning(error.response.data.message);
        console.error('Error updating booking:', error);
    }
};

export const handleGuUpdateNow = async ({
    booking,
    confirmedBookingData,
    updateUserBookingDateAndPickupLocation,
    naviagte
}) => {
    console.log(booking, confirmedBookingData);
    const dateChanged = String(confirmedBookingData?.guDatesId) !== String(booking?.guDatesId);

    const slotChanged = String(confirmedBookingData?.slotId) !== String(booking?.slotId);

    const meetupChanged = confirmedBookingData?.meetupLocation.name !== booking?.meetupLocation.name;

    const dateFlag = dateChanged || slotChanged;
    const meetupFlag = meetupChanged;

    const updateBody = {
        bookingId: confirmedBookingData?._id,

        // Date / slot update
        ...(dateFlag && {
            newGuDatesId: booking?.guDatesId,
            newSlotId: booking?.slotId,
            newDate: booking?.date
        }),

        // Meetup location update
        ...(meetupFlag && {
            meetupLocation: booking?.meetupLocation
        })
    };

    console.log('Guide UPDATE');
    console.log('dateChanged:', dateChanged);
    console.log('slotChanged:', slotChanged);
    console.log('meetupChanged:', meetupChanged);
    console.log('dateFlag:', dateFlag);
    console.log('pickupFlag:', meetupFlag);
    console.log('updateBody:', updateBody);

    if (!dateFlag && !meetupFlag) {
        toast.warning('No changes were made');
        return;
    }

    try {
        const response = await updateUserBookingDateAndPickupLocation('gu', dateFlag, meetupFlag, updateBody);

        if (response.status === 200) {
            toast.success(
                dateFlag && meetupFlag
                    ? 'Guide date and location updated successfully'
                    : dateFlag
                      ? 'Guide date updated successfully'
                      : 'Guide location updated successfully'
            );

            sessionStorage.removeItem('confirmedBookingData');

            naviagte('/my-booking');
        }
    } catch (error) {
        console.error('Error updating activity booking:', error);

        toast.warning(error?.response?.data?.message || 'Unable to update activity booking');
    }
};
